/** @format */

import NProgress from 'nprogress'; // progress bar
import { useGlobalStoreWithOut } from '@power/runtime-vue3';
import { Storage } from '@power/utils';
import { type WhiteNameList, LOGIN_NAME } from './constant';
import { matchedCommonPathComponent } from './utils';
import type { Router } from 'vue-router';
import { useMenuStore } from '@/store/modules/menu';
import { ACCESS_TOKEN_KEY } from '@/enums/cacheEnum';
// import { getTips } from '@/utils/license';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const defaultRoutePath = '/';

let countPageNotFound = 0;

export function routerHasRoute(router: Router, routePath: string) {
	const routes = router.getRoutes();
	// console.log('routes', routes);
	// console.log('routePath', routePath);

	const filterRoute = routes.filter((route) => {
		if (route.path === routePath) {
			return route;
		}
		return false;
	});
	if (filterRoute.length > 0) {
		return true;
	} else {
		const matchedObj = matchedCommonPathComponent(routePath);
		if (matchedObj) {
			return true;
		}
		return false;
	}
}

export function createRouterGuards(router: Router, whiteNameList: WhiteNameList) {
	// console.log('createRouterGuards,router', router);
	// console.log('createRouterGuards,router.getRoutes()', router.getRoutes());

	router.beforeEach(async (to, from, next) => {
		// console.log('createRouterGuards.beforeEach,router.getRoutes()', router.getRoutes());
		// console.log('createRouterGuards.beforeEach,to, from, next', to, from, next);

		if (to.name && to.name === from.name && to.fullPath === from.fullPath && to.hash === '') {
			//console.log('to.name', to.name);
			//console.log('from.name', from.name);
			next(false); //中断当前路由
			return;
		}
		const globalStore = useGlobalStoreWithOut();
		const menuStore = useMenuStore();
		NProgress.start(); // start progress bar
		const token = Storage.get(ACCESS_TOKEN_KEY, null);
		if (whiteNameList.some((n) => n === to.name)) {
			// 在白名单，直接进入
			next();
			return;
		}

		if (token) {
			if (to.name === LOGIN_NAME) {
				next({ path: defaultRoutePath });
				NProgress.done();
			} else {
				// 如果不需要每次切换路由获取最新的动态路由，可把下面注释放开
				if (menuStore.displayMenus.length === 0) {
					// 从后台获取菜单
					if (menuStore.url) {
						await menuStore.initCurSidebarByUrl(menuStore.url, menuStore.name || globalStore.curSystemAlias);
					} else if (globalStore.curSystemAlias) {
						await menuStore.initCurSidebarByInnerSystemName(globalStore.curSystemAlias);
					} else {
						await menuStore.initCurSidebarByLocalConfig(menuStore.name);
					}
					menuStore.initCurSidebarDisplayMenusAndDynamicRouter();
					if (to.name === 'PageNotFound') {
						if (1 === countPageNotFound) {
							countPageNotFound = 0;
						} else {
							countPageNotFound = 1;
							if (to.redirectedFrom && to.redirectedFrom.path !== '/error/404') {
								// console.log('to.redirectedFrom', to.redirectedFrom);
								const hasRoute = routerHasRoute(router, to.redirectedFrom.path);
								// console.log('hasRoute', hasRoute);
								if (hasRoute) {
									next({
										path: to.redirectedFrom.path,
										query: to.redirectedFrom.query,
										replace: true,
									});
									return;
								}
							}
						}
					}
					const hasRoute = router.hasRoute(to.name!);
					if (!hasRoute) {
						// 请求带有 redirect 重定向时，登录自动重定向到该地址
						const redirect = decodeURIComponent((from.query.redirect || '') as string);
						if (to.path === redirect) {
							next({ ...to, replace: true });
						} else {
							// 跳转到目的路由
							next({ ...to, replace: true });
						}
					} else {
						// 直接进入
						next();
					}
				} else {
					if (to.name === 'PageNotFound') {
						if (1 === countPageNotFound) {
							countPageNotFound = 0;
						} else {
							countPageNotFound = 1;
							if (to.redirectedFrom && to.redirectedFrom.path !== '/error/404') {
								// console.log('to.redirectedFrom', to.redirectedFrom);
								const hasRoute = routerHasRoute(router, to.redirectedFrom.path);
								// console.log('hasRoute', hasRoute);
								if (hasRoute) {
									next({
										path: to.redirectedFrom.path,
										query: to.redirectedFrom.query,
										replace: true,
									});
									return;
								}
							}
						}
					}
					next();
				}
			}
		} else {
			// not login
			next({ name: LOGIN_NAME, query: { redirect: to.fullPath }, replace: true });
			NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
		}
	});

	router.afterEach((to, from) => {
		NProgress.done(); // finish progress bar
		if (to.path != '/login' && from.path == '/') {
			// getTips();
		}
	});

	router.onError((error) => {
		console.log(error, '路由错误');
	});
}
